/*global Handlebars, moment, $, scriptLoader, WebView, ServiceClient, ViewController, FormController, AppController, GridAndFormController, mocha, DatabaseClient, ImporterController, io, protocolCheck */

var offlineRuntime = require('offline-plugin/runtime');


//hide splash
var splashcreen = document.getElementById("loader") ;
var updateVersion = document.getElementById("update-version") ;
var loadProgress = document.getElementById("load-progress") ;
var loadProgressBar = document.getElementById("load-progress-bar") ;



function installOffline(installNewVersion){
    // don't install offline when running testcafe
    if(window['%hammerhead%'] || window.location.href.startsWith("http://localhost")){ 
        splashcreen.className += " hide" ;
        return ; 
    }

    var quotaNeeded = 50000000;
    var estimateStorage = function(callback){
        return callback({usage: 0, quota: quotaNeeded*2}) ;
    } ;
    if(navigator.storage && navigator.storage.estimate){
        estimateStorage = function(callback){
            navigator.storage.estimate().then(function(usage){
                callback(usage) ;
            });
        } ;
    }else if ('webkitTemporaryStorage' in navigator && typeof navigator.webkitTemporaryStorage.queryUsageAndQuota === 'function') {
        estimateStorage = function(callback){
            navigator.webkitTemporaryStorage.queryUsageAndQuota(function(usage, quota) {
                callback({usage: usage, quota: quota});
            });
        } ;
    }
    
    estimateStorage(function(usage){ 
        if(usage.quota - usage.usage < quotaNeeded){
            //not enough storage, don't install offline
            console.log("not enough storage, remove service workers to force last version", usage.quota, usage.usage) ; 
            if(navigator.serviceWorker && navigator.serviceWorker.getRegistrations){
                navigator.serviceWorker.getRegistrations().then(function(registrations) {
                    registrations.forEach(function(registration){
                        registration.unregister();
                    }) ;
                }) ;
            }
            return ;
        }
        let updateReady = function(){
            if(installNewVersion){
                console.log("NEW VERSION LOADED, RELOAD PAGE");
                splashcreen.className += " hide" ;
                window.location.reload();
            }else{
                console.log("NEW VERSION LOADED, DISPLAY RELOADER");
                let elI18n = updateVersion.querySelectorAll("[data-i18n]");
                for(let i=0; i<elI18n.length; i++){
                    let str = elI18n[i].getAttribute("data-i18n") ;
                    elI18n[i].innerHTML = WebView.tr(str) ;
                }
                updateVersion.style.display = "block" ;
            }
        } ;
        offlineRuntime.install({
            onUpdating: function() {
                console.log('SW Event:', 'onUpdating', splashcreen.className, arguments);
                // splashcreen.className += " updating" ;
            },
            onUpdateReady: function() {
                console.log('SW Event:', 'onUpdateReady', arguments);
                // Tells to new SW to take control immediately
                offlineRuntime.applyUpdate();
            },
            onUpdated: function() {
                console.log('SW Event:', 'onUpdated', arguments);
                // Reload the webpage to load into the new version
                updateReady();
            },
        
            onUpdateFailed: function() {
                console.log('SW Event:', 'onUpdateFailed', splashcreen.className, arguments);
                // splashcreen.className.replace(/updating/g, "") ;
            },
            onInstalled:function() {
                console.log('SW Event:', 'onInstalled', splashcreen.className, arguments);
                console.log("FIRST LOAD, no reload needed");
                splashcreen.className += " hide" ;
            }
        });
        try{
            if(navigator.serviceWorker && navigator.serviceWorker.getRegistrations){
                navigator.serviceWorker.getRegistrations().then(function(registrations) {
                    registrations.forEach(function(registration){
                        console.log("SW Event: Check SW update") ;
                        try{
                            registration.update().catch(function(e){
                                console.log("SW Event: Check update failed", e) ;
                            });
                        }catch(e){
                            console.log("SW Event: Check update failed", e) ;
                        }
                    }) ;
                }).catch(function(e){
                    console.log("SW Event: Check update failed", e) ;
                }) ;
            }
        }catch(e){
            console.log("SW Event: Check update failed", e) ;
        }
    }) ;

}

var libs = require("./config/libs") ;
var pkg = require("../package.json") ;
//

scriptLoader.setOptions({
    policy: "npm",
    npmPath: "node_modules"
}) ;


var libsToLoad = libs ;
var loadTotal = 15;
libsToLoad.forEach(function(l){
    if(Array.isArray(l)){
        loadTotal+=l.length;
    }else{
        loadTotal++ ;
    }
}) ;
var loadCurrent = 0 ;
function updateProgress(currentValue){
    if(currentValue){
        loadCurrent = currentValue ;
    }else{
        loadCurrent += 1 ;
    }
    //console.log(loadCurrent+"/"+loadTotal) ;
    loadProgressBar.style.width = (100*loadCurrent/loadTotal)+"%" ;
}
if(process.env.MODE === "development"){
    var libsTest = require("./config/libsTest") ;
    libsToLoad = libsToLoad.concat(libsTest);
}

window.IZEE_MODULES = [] ;
window.registerModule = function(module){
    window.IZEE_MODULES.push(module) ;
} ;

scriptLoader.load(libsToLoad, function(err){
    if(err){ return alert("Can't load view library "+JSON.stringify(err)) ;}


    if(process.env.MODE === "development"){
        WebView.debugMode = true;
    }

    Handlebars.registerHelper("formatDate", function(datetime, format) {
        return moment(datetime).format(format);
    });
    Handlebars.registerHelper("ellips", function(str, len) {
        if(str && str.length>len){
            str = str.substring(0, len)+"..." ;
        }
        return str;
    });
    Handlebars.registerHelper("tr", function(str) {
        return WebView.tr(str);
    });

    //Bootstrap 4 extension (should put in external extension)
    WebView.registerExtension({
        name: 'bootstrap-4',
        init: function(){
            var view = this;

            // var clearDropdownId = null;

            view.on("render", function(){
                //run only on root view, not on subviews
                if(view.parentView){ return ; }
                view.ensureDisplayed(function(){
                    //init tooltips
                    $(".tooltip").remove() ;
                    $(view.viewRootEl).find('[data-toggle="tooltip"]').tooltip("dispose") ;
                    $(view.viewRootEl).find('[data-toggle="tooltip"]').tooltip({
                        container: 'body',
                        boundary: "window"
                     }) ;


                     $(".bs-container.dropdown").remove() ;
                    // if(clearDropdownId){ clearTimeout(clearDropdownId) ; }
                    // clearDropdownId = setTimeout(function(){
                    //    var allDropDown = document.querySelectorAll(".bs-container.dropdown") ;
   
                    //    for(var i=0; i<allDropDown.length; i++){
                    //        var elParent = allDropDown[i].parentElement ;
                    //        if(elParent){
                    //            //elParent.removeChild(allDropDown[i]) ;
                    //        }
                    //    }
                    // }, 2000) ;
                }) ;

            });
        }
    });

    var objectsToInject = {} ;

    var confCalls = [] ;

    var i18nConfiguration = require("./config/i18n") ;
    if(i18nConfiguration){
        confCalls.push(function(cb){
            WebView.i18n.configure(i18nConfiguration, cb) ;
        }) ;
    }


    var offlineConfig = require("./config/offlineConfig") ;
    if(offlineConfig){
        if(!DatabaseClient.setOfflineTableSettings){
            return alert("Yo gave offline settings but not include the offline sync lib") ;
        }
        confCalls.push(function(cb){
            DatabaseClient.setOfflineTableSettings(offlineConfig.offlineTableSettings) ;
            cb() ;
        }) ;
    }


    var apiConfiguration = require("./config/apiConfig") ;
    if(apiConfiguration){
        confCalls.push(function(cb){
            var api = new ServiceClient(apiConfiguration) ;

            objectsToInject.api = api ;
    
            api.addEndPoints(require("./config/endpoints.js")) ;
    
            
            var onerror = function (error) {
                
                //ignore quill errors
                if(error && error instanceof PromiseRejectionEvent){
                    console.log("ignore promise rejection event", error) ;
                    return;
                }
                if(error && error.filename && error.filename.indexOf("inputmask") !== -1) { 
                    console.log("error in inputmask", error) ;
                    return ; 
                }
                if(error && error.filename && error.filename.indexOf("quill") !== -1) { return ; }
                if(error && error.filename && error.filename.indexOf("bootstrap-select") !== -1) { return ; }
                if(error && error.filename && error.filename.indexOf("ag-grid") !== -1) { return ; }
                if(window.navigator.userAgent && window.navigator.userAgent.includes("Googlebot")){ return ; }
                
                //"normal" error : https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
                if(["encountered an error during installation", "Failed to update a ServiceWorker", "sw.js load failed", "not connected", "ResizeObserver loop"].some(function(msg){
                    if(error && typeof(error) === "string" && error.indexOf(msg) !== -1){
                        return true; 
                    }
                    if(error && error.message && typeof(error.message) === "string" && error.message.indexOf(msg) !== -1){
                        return true; 
                    }
                    if(error && error.reason && error.reason.message && typeof(error.reason.message) === "string" && error.reason.message.indexOf(msg) !== -1){
                        return true; 
                    }
                })){
                    return; //ignore
                }
                if(window.runningTest){
                    return; //don't catch error in test mode
                }
                if(error && error.reason instanceof Error){
                    //case of error happen in promise
                    error.message = error.reason.message ;
                    error.error = error.reason ;
                }
                var msg = "";
                try{
                    msg = error.message || error.reason ;
                    if(!msg){
                        try{
                            msg = JSON.stringify(error) ;
                        }catch(errStringify){
                            msg = ""+err ;
                        }
                    }
                    if(error.error){
                        var stack = error.error.stack ;
                        if(stack){
                            msg += "\n"+stack ;
                        }
                    }
                    if(msg.indexOf('opening routes "not connected"') !== -1 ){
                        return ;
                    }
                    if(msg.indexOf('modify routes "not connected"') !== -1 ){
                        return ;
                    }
                    if(msg.indexOf('Error while opening routes') !== -1 ){
                        return ;
                    }
                    if(msg.indexOf('The operation is insecure') !== -1 ){
                        return ;
                    }
                    var unexpectedErrorMsg = WebView.tr("global.unexpectedError") ;
                    WebView.error(unexpectedErrorMsg+"\n"+msg) ;
                    
                }catch(err){
                    console.log("error while display unexpected error message...", err, error) ;						
                }
                try{
                    var report = {
                        app_name : pkg.name,
                        app_version: pkg.version,
                        date : new Date(),
                        user_agent: window.navigator.userAgent,
                        user_uid: api.currentUser?api.currentUser.id:"anonymous",
                        url: window.location.href,
                        error: msg
                    } ;
                    api.saveCrashReport(report, function(err){
                        if(err){
                            console.log("error while sending crash report") ;
                        }
                    }) ;
                }catch(err){
                    console.log("error while sending crash report...", err, error) ;						
                }
                return false;

            } ;

            window.addEventListener("error", onerror ) ;
            window.addEventListener("unhandledrejection", onerror ) ;

            //init api
            api.init(function(err){
                if(err){ 
                    if(err === "NO_DB_NAME"){
                        scriptLoader.load(
                            [
                                {name: "bootstrap-theme-v2",
                                    type: "css",
                                    version: "1.0.0",
                                    localPath: "css/theme_v2.css",
                                },
                            ], function(err){
                            if(err){ console.log(err) ; }
                
                            var lastLoginUrl = localStorage.getItem("last_login_url") ;
                            if(lastLoginUrl && document.location.href.indexOf(lastLoginUrl) !== 0){
                                document.location.href = lastLoginUrl+document.location.hash ;
                                return;
                            }
                            var viewChooseUrl = new WebView("views/login", "chooseUrl", { container: "main" }) ;
                            var data = {} ;
                            viewChooseUrl.open(data) ;
                            viewChooseUrl.on("choose", function(){
                                viewChooseUrl.updateData() ;
                                if(!data.url){ return WebView.error(WebView.tr("login.pleaseChooseUrl")) ; }
                                if(data.url.indexOf("#") !== -1){
                                    data.url = data.url.substring(0, data.url.indexOf("#")) ;
                                }
                                localStorage.setItem("last_login_url", data.url) ;
                                document.location.href = data.url+document.location.hash ;
                            }) ;
                            splashcreen.parentElement.removeChild(splashcreen);
                            return;
                        });
                    }
                    return WebView.error(err);
                }

                objectsToInject.apip = window.promifyObject(api) ;
    
                
                api.db.getSchema(function(err, schema){
                    if(err){ 
                        return WebView.error(err);
                    }
                    
                    api.socket = io.connect(api.options.serverUrl+schema.__dbName);                 
                    api.socket.on("error", function(err){
                        console.log("socket error", err) ;
                    }) ;
                    api.socket.on("disconnect", function(err){
                        console.log("socket disconnect", err) ;
                    }) ;
                    api.socket.on("reconnect", function(err){
                        console.log("socket reconnect", err) ;
                    }) ;
                    api.socket.on("reconnecting", function(err){
                        console.log("socket reconnecting", err) ;
                    }) ;
                    api.socket.on("reconnect_error", function(err){
                        console.log("socket reconnect_error", err) ;
                    }) ;
                    api.socket.on("reconnect_failed", function(err){
                        console.log("socket reconnect_error", err) ;
                    }) ;
                    var protocolUuid = WebView.uuid();
                    api.socket.on('protocolList', function(event){
                        if(event.data.token == protocolUuid){
                            localStorage.setItem("iz-protocol-list", event.data.list);
                            console.log(JSON.stringify(event.data.list));
                        }
                    });
                    api.socket.on("connect", function(){
                        var ua = navigator.userAgent.toLowerCase();
                        var isSafari = (~ua.indexOf('safari') && !~ua.indexOf('chrome')) || Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
                        var isMobile = /android|ip(hone|od|ad)/i.test(navigator.userAgent);
                        var isFrame = window.self !== window.top ;
                        var url = "owlist:"+api.options.serverUrl+"api/protocol/list/?dbname="+schema.__dbName+"&token="+protocolUuid;
                        
                        if(isMobile || isFrame){
                            //don't search owork toolkit on mobile
                            return ;
                        }
                        if(isSafari){
                            //safari don't allow to use custom font in browser so it can't detect that the toolkit is installed or not
                            try{
                                protocolCheck(url);
                            }catch(err){
                                console.log("Protocol check not supported", err) ;
                            }
                        }else{
                            var div1 = document.createElement('div');
                            var div2 = document.createElement('div');

                            div1.innerHTML = "tool-kit";
                            div2.innerHTML = "tool-kit";

                            div1.style.fontFamily = "Extremely Small Fonts, Arial";
                            div2.style.fontFamily = "Arial";

                            div1.style.fontSize = "18pt";
                            div2.style.fontSize = "18pt";
                            div1.style.display = "inline";
                            div2.style.display = "inline";

                            if(!document.body){ return ; }

                            document.body.appendChild(div1);
                            document.body.appendChild(div2);

                            if(Math.abs(div1.offsetWidth - div2.offsetWidth) > 3){ //more than 3 pixel difference, the font is here
                                //the font is installed which means that the toolkit is installed on the computer
                                if(localStorage.getItem("iz-protocol-list")){
                                    //We already asked to the protocol list, don't ask again
                                }else{
                                    //open the owlist protocol to get the list of protocol handled by toolkit
                                    try{
                                        protocolCheck(url);
                                    }catch(err){
                                        console.log("Protocol check not supported", err) ;
                                    }
                                }
                            } else {
                                localStorage.removeItem("iz-protocol-list") ;
                            }

                            document.body.removeChild(div1);
                            document.body.removeChild(div2);
                        }
                    }) ;


                    if(WebView.fieldsSchema){
                        WebView.fieldsSchema.configure({
                            schema: schema, 
                            apiClient: api, 
                        //    schemaExtend: schemaExtends,
                            addLabelToFields : true,
                            addErrorsToFields : true
                        }) ;
                    }

                    if(WebView.fields){
                        WebView.fields.configure({
                            apiClient: api, 
                        }) ;
                    }                  

                    cb() ;
                }) ;
            }) ;
        }) ;    
    }

    confCalls.push(function(cb){
        if(ServiceClient.setOfflineBinaryStorageEngine && window.native && window.native.binaryStorage){
            ServiceClient.setOfflineBinaryStorageEngine(window.native.binaryStorage);
        }
        cb() ;
    }) ;

    WebView._asyncSeries(confCalls, function(err){
        if(err){ 
            return WebView.error(err);
        }
        updateProgress(loadCurrent+confCalls.length) ;

        ViewController.setDefaultContainerParent("views") ;


        WebView.fields.addDecorator(function bootstrap4decorator(element, fieldType){
            if(fieldType === "select" || fieldType === "selection" || fieldType === "multiple"){
                element.className += " form-group" ;
                var selectMultiple = element.querySelector(".select-multiple-container") ;
                if(selectMultiple){
                    selectMultiple.className += " form-control" ;
                }else{
                    var select = null;
                    if(element.tagName === "SELECT"){
                        select = element;
                    }else{
                        select =  element.querySelector(".bootstrap-select") ;
                        if(!select){
                            select = element.getElementsByTagName("select")[0] ;
                        }
                    }
                    select.className += " form-control" ;
                }
                return ;
            }
            
            if(fieldType === "textarea"){
                var textarea = element.getElementsByTagName("textarea")[0] ;
                element.className += " form-group" ;
                textarea.classList.add("form-control") ;
                return ;
            }
            if(fieldType === "radio" || fieldType === "checkboxes"){
                var inputs = Array.prototype.slice.apply(element.getElementsByTagName("input")) ;
                var isInline = element.hasAttribute("data-inline") ;
                for(var i=0; i<inputs.length; i++){
                    var input = inputs[i] ;
                    var label = input.nextSibling ;
                    input.className += " form-check-input";
                    label.className += " form-check-label";
                    var div = document.createElement("DIV") ;
                    div.className = "form-check" ;
                    if(isInline){
                        div.className += " form-check-inline" ;
                    }
                    div.appendChild(input);
                    div.appendChild(label);
                    element.appendChild(div) ;
                }
                return ;
            }
            if(fieldType === "upload" || fieldType === "pdf"){
                return;
            }
            if(fieldType === "grid" ){
                var tables = element.getElementsByTagName("table") ;  
                for(var i=0; i<tables.length; i++){
                    tables[i].className += " table table-striped table-bordered table-hover dt-responsive nowrap" ;
                }
                var refreshButton = element.querySelector(".table-custom-button-refresh") ;
                if(refreshButton){
                    refreshButton.innerHTML = '&nbsp;<i class="fas fa-sync"></i>&nbsp;' ;
                }
                var createButton = element.querySelector(".table-custom-button-createNew") ;
                if(createButton){
                    createButton.className = createButton.className.replace("btn-outline-secondary", "btn-primary") ;
                }
                return;
            }
            var input = element.getElementsByTagName("input")[0] ;
            if(input){
                if(input.type === "checkbox"){
                    if(fieldType !== "toggle"){
                        element.className += " form-check" ;
                        var label = element.getElementsByTagName("label")[0] ;
                        if(label){
                            label.className += " form-check-label" ;
                        }
                        input.className += " form-check-input";
                    }
                }else{
                    element.className += " form-group" ;
                    input.className += " form-control" ;
                }
            }else{
                element.className += " form-group" ;
            }

            if(fieldType === "suggest" ){
                var secondInput = element.querySelector(".tt-input") ;
                if(secondInput){
                    secondInput.className += " form-control" ;
                }
            }

            var pickerMobile = element.querySelector(".flatpickr-mobile") ;
            if(pickerMobile){
                pickerMobile.className += " form-control" ;
            }
            
            
        }) ;

        if(FormController){
            FormController.setOptions({
                buttonsHTML: require("./views/global/form-buttons.html")
            }) ;
        }

        // var loginController = require("./controllers/loginController") ;

        var app = new AppController() ;
        window.app = app ;
        app.context = { controllers: {}, embeddables: {}} ;
        Object.keys(objectsToInject).forEach(function(k){
            app.context[k] = objectsToInject[k] ;
            app.injectToControllers(k, objectsToInject[k]) ;
        }) ;

        var checkProspectConvertion = require("./modules/refs/utils/checkProspectConvertion") ;

        window.app.injectToControllers("customerFunctions", {
            checkProspectConvertion : checkProspectConvertion.checkProspectConvertion,
            checkProspectFields : checkProspectConvertion.checkProspectFields,
            checkProspectConvertionFullObject : checkProspectConvertion.checkProspectConvertionFullObject,
        }) ;

        var requireControllers = require.context("./controllers", true, /^\.\/.*\.js$/) ;

        var callsStartup = [] ;

        window.app.context.api.public.getGlobalSettings(function(err, settings){
            if(err){ return WebView.error(err); }

            var CustomScreenControllers = require("./libs/controller/CustomScreenControllers");
            for(let screen of settings.customScreens){
                try{
                    var customScreenController = CustomScreenControllers.createCustomController(screen) ;
                    var controllerCode = "custom_"+screen.code ;
                    window.app.context.controllers[controllerCode] = customScreenController ;
                    window.app.registerController(customScreenController) ;
                }catch(err){
                    console.error("Error while init screen", screen, err) ;
                }
            }
        
            var isV2 = settings && settings.use_v2;
            window.app.context.isV2 = isV2 ;
            window.app.context.hostname = settings?settings.hostname:"" ;
            window.app.context.hasPackage = settings && settings.packages && settings.packages.length>0 ;

            scriptLoader.load(
                [
                    {name: "bootstrap-theme"+isV2?"-v2":"-v1",
                        type: "css",
                        version: "1.0.0",
                        localPath: isV2?"css/theme_v2.css":"css/theme.css",
                    },
                ], function(err){
                    if(err){ return WebView.error(err); }

                requireControllers.keys().forEach(function(c){
                    var controller = requireControllers(c);
                    app.context.controllers[c.match(/([a-zA-Z0-9]+)\.js$/m)[1]] = controller ;
                    app.registerController(controller) ;
                });

                var requireInterceptors = require.context("./interceptors", true, /^\.\/.*\.js$/) ;

                var allInterceptors = [] ;
                requireInterceptors.keys().forEach(function(c){
                    var interceptors = requireInterceptors(c);
                    interceptors.forEach(function(interceptor){
                        allInterceptors.push(interceptor) ;
                    });
                });
                allInterceptors.sort(function(i1, i2){
                    return (i1.order||99999)-(i2.order||99999) ;
                }).forEach(function(interceptor){
                    if(interceptor.type === "ajax"){
                        app.context.api.addAjaxInterceptor(function(err, request, response, next){
                            interceptor.interceptor(app, err, request, response, next) ;
                        }) ;
                    }else if(interceptor.type === "navigation"){
                        app.addInterceptor(function(context, next){
                            interceptor.interceptor(app,context, next) ;
                        }) ;
                    }else if(interceptor.type === "preNavigation"){
                        app.addNavigationInterceptor(function(context, callback){
                            interceptor.interceptor(app,context, callback) ;
                        }) ;
                    }else if(interceptor.type === "startup"){
                        callsStartup.push(function(cb){
                            updateProgress() ;
                            interceptor.interceptor(app, cb) ;
                        }) ;
                    }else{
                        WebView.error("unkown interceptor type "+interceptor.type);
                    }
                }) ;

                WebView._asyncSeries(callsStartup, function(err){
                    if(err){ 
                        return WebView.error(err);
                    }

                    var requireEmbeddables = require.context("./embeddables", true, /^\.\/.*\.js$/) ;

                    requireEmbeddables.keys().forEach(function(c){
                        var controllerClass = requireEmbeddables(c);
                        app.context.embeddables[c.match(/([a-zA-Z0-9]+)\.js$/m)[1]] = controllerClass ;
                    });
                    
                    document.title = WebView.tr("global.appName") ;

                    setTimeout(function(){
                        updateProgress(loadCurrent+2) ;
                    }, 100) ;
                    setTimeout(function(){
                        updateProgress(loadCurrent+2) ;
                    }, 200) ;
                    app.onNavigate(async function(){
                        updateProgress(loadTotal) ;
                        //hide splash

                        splashcreen.addEventListener("transitionend", function(){
                            splashcreen.className += " hide-done" ;
                            setTimeout(function(){
                                if(splashcreen.parentElement){
                                    splashcreen.parentElement.removeChild(splashcreen);
                                }
                            }, 10) ;
                        }) ;

                        console.log("CHECK VERSION...");
                        try{
                            let response = await fetch("/version") ;
                            let versionServer = await response.text() ;
                            let versionClient = localStorage.getItem("version") ;
                            if(versionServer !== versionClient){
                                localStorage.setItem("version", versionServer) ;
                                console.log("VERSION CHANGED "+versionClient+" -> "+versionServer);
                                if(window['%hammerhead%']){ //skip if testcafe
                                    splashcreen.className += " hide" ;
                                }else{
                                    setTimeout(()=>{
                                        window.location.reload() ;
                                    }, 5000);
                                    if(navigator.serviceWorker && navigator.serviceWorker.getRegistrations){
                                        (async ()=>{
                                            let registrations = await navigator.serviceWorker.getRegistrations() ;
                                            for(let registration of registrations){
                                                await registration.unregister();
                                            }
                                            window.location.reload() ;
                                        })() ;
                                    }
                                }                                
                            }else{
                                console.log("no version change", versionServer);
                                splashcreen.className += " hide" ;
                                installOffline() ;
                            }
                        }catch(err){
                            console.log("Can't check version", err);
                            splashcreen.className += " hide" ;
                            installOffline() ;
                        }
                    }) ;
                    
                    //install offline only if not running testcafe
                    //installOffline() ;
                    objectsToInject.api.public.customCss(function(err, css){
                        if(!err){ 
                            WebView.loadStaticCss(css) ;
                        }
                    });
                    if(process.env.MODE === "development"){
                        var runTest = null;
                        if(window.location.search){
                            var params = window.location.search.substring(1).split("&") ;
                            params.forEach(function(paramPair){
                                var param = paramPair.split("=") ;
                                if(param[0] === "runTest"){
                                    runTest = param[1] ;
                                }
                            });
                        }
                        if(runTest){
                            window.runningTest = true ;
                            var divMocha = document.createElement("DIV") ;
                            divMocha.id = "mocha" ;
                            divMocha.style.position = "absolute" ;
                            divMocha.style.top = 0 ;
                            divMocha.style.bottom = 0 ;
                            divMocha.style.left = 0 ;
                            divMocha.style.right = 0 ;
                            divMocha.style.backgroundColor = "rgba(255, 255, 255, 0.81)" ;
                            divMocha.style.display = "none" ;
                            divMocha.style.zIndex = 999999 ;
                            document.body.appendChild(divMocha) ;
                            window.controllers = {} ;
                            app.controllers.forEach(function(ct){
                                if(ct.viewOptions){
                                    window.controllers[ct.viewOptions.name] = ct ;
                                }else if (ct instanceof GridAndFormController){
                                    window.controllers[ct.table] = ct ;
                                }
                            }) ;
                            mocha.setup('bdd') ;
                            var testsToRun = [] ;
                            if(runTest === "all"){
                                var requireTests = require.context("../tests", true, /^\.\/.*\.js$/) ;

                                testsToRun = requireTests.keys().map(function(t){ return "tests/"+t.replace(/^\.\//, "") ;}) ;
                            }else{
                                testsToRun = runTest.split(",").map(function(t){ return "tests/"+t+".js" ;}) ;
                            }
                            scriptLoader.load(testsToRun.map(function(t){
                                return {
                                    name: t,
                                    type: "js",
                                    version: 1,
                                    localPath: t
                                } ;
                            }), function(){
                                mocha.checkLeaks();
                                mocha.globals(["JSZip", "__core-js_shared__", "pdfMake", "createPdf", "Inputmask", "Decimal"]) ;
                                mocha.run(function(){
                                    console.log("finished") ;
                                    divMocha.style.display = "block" ;
                                    var mochaStats = divMocha.querySelector("#mocha-stats") ;
                                    if(mochaStats){
                                        mochaStats.style.zIndex = 9999;
                                        mochaStats.style.backgroundColor = "white";
                                    }
                                });
                            });
                        }
                    }
                });
            });
        }) ;
    }) ;
}, function callbackProgress(){
    updateProgress() ;
}) ;